import { render, staticRenderFns } from "./HardwareOfferPriceInTokens.vue?vue&type=template&id=daa4eb08"
import script from "./HardwareOfferPriceInTokens.vue?vue&type=script&lang=ts"
export * from "./HardwareOfferPriceInTokens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports